<template>
  <div>
    <b-table
      id="#my-invoices-table"
      ref="myInvoicesTable"
      show-empty
      :empty-text="noInvoicesText"
      :no-border-collapse="true"
      :items="invoices"
      :fields="fields"
      :busy="busy"
      striped
      hover
      class="b-table bg-white shadow table border"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :no-local-sorting="true"
      :sort-icon-left="true"
      :tbody-tr-class="setRowStyle"
      @sort-changed="loadInvoices"
    >
      <template v-slot:head(select)=""
                class="m-auto"
      >
        <b-button v-if="unpaid.length > 0" class="select-all m-0 p-0" variant="link" @click="setAll(!allSelected)">
          {{ unpaid.length > 0 ? (allSelected ? $t('De-Select All') : $t('Select All')) : '' }}
        </b-button>
        <span v-else />
      </template>
      <template v-slot:cell(select)="data">
        <b-form-checkbox v-if="canSettle(data.item)" :checked="data.value" @change="rowSelected(data.index)" />
      </template>
      <template v-slot:cell(payment_at)="data">
        {{ data.item | invoicePayment }}
      </template>
      <template v-slot:cell(created_date)="data">
        {{ data.value | parseDate }}
      </template>
      <template v-slot:cell(price_including_vat)="data">
        {{ $n(data.value, 'currency') }}
      </template>
      <template v-slot:cell(view)="data">
        <b-button variant="outline-secondary" size="sm" @click="onViewInvoice(data.item)">
          {{ $t('View') }}
        </b-button>
      </template>
      <template v-slot:cell(pdf)="data">
        <a :href="pdfLocation(data.item.code)" class="btn btn-sm btn-outline-secondary">
          <font-awesome-icon icon="download" />
          <span v-if="!compact" class="d-sm-inline">{{ $t('PDF') }}</span>
        </a>
      </template>
      <template v-slot:cell(pay_now)="data">
        <b-button v-if="canSettle(data.item)" :disabled="data.item.select" variant="primary" size="sm" @click="rowSelected(data.index, true)">
          <span v-if="!compact" class="d-sm-inline">{{ $t('Pay Now') }}</span>
        </b-button>
      </template>
      <template v-slot:table-busy>
        <div class="text-center">
          <spinner :display-loading="true" />
        </div>
      </template>
    </b-table>
    <b-pagination v-model="page" :total-rows="items" :per-page="pageSize" aria-controls="my-leads-table" align="right" />
  </div>
</template>

<script>
import Spinner from "@/components/animation/Spinner";
import invoiceList from "@/imports/mixins/invoiceList";
import { captureError } from "@/services/userMonitoring";

export default {
  name: "MyInvoicesTable",
  components: {Spinner},
  mixins: [invoiceList],
  props:['fields', 'filter', 'compact', 'value'],
  data() {
    return {
      busy: false,
      items: 0,
      pageSize: 10,
      invoices: [],
      sortBy: 'created_date',
      sortDesc: true,
      cachedInvoices: []
    }
  },
  computed: {
    allSelected: function() {
      return this.unpaid.filter((invoice) => (invoice.select === false)).length === 0;
    },
    unpaid: function() {
      return this.invoices.filter(invoice => this.canSettle(invoice));
    },
    page: {
      get: function() {
        return this.$route.query.page ?? 1;
      },
      set: function(value) {
        if (this.$route.query.page !== value) {
          this.$router.push({name:'invoices', query:{...this.$route.query, page:value}});
        }
      }
    },
    sortOrder: function() {
      return this.sortBy ? (this.sortBy + '-' + (this.sortDesc ? 'desc' : 'asc')) : null;
    },
    noInvoicesText() {
      return this.$t('Sorry, you do not have any invoices currently')
    },
  },
  methods: {
    loadInvoices: async function() {
      try {
        this.busy = true;
        let result = await this.$api.invoices.list({page: this.page, sort: this.sortOrder});
        this.setMeta(result.data.meta);
        this.invoices = result.data.data.map((invoice) => ({...invoice, select: this.cachedInvoices.find(el => el.id === invoice.id) !== undefined}));
        this.busy = false;
        this.$emit('invoices-loaded');
      } catch (e) {
        captureError(e, {
          section: "invoices",
          action: "load-invoices",
          type: "api-request"
        });
      }
    },
    setRowStyle: function(item, type) {
      if (!item || type !== 'row') return;
      let trClass = [];
      if (this.value && this.value.code === item.code) {
        trClass.push('b-table-row-selected ');
        trClass.push('table-active');
      }
      return trClass.join(' ');
    },
    deselectAll: function() {
      this.setAll(false);
    },
    invoiceProvider: async function() {
      await this.loadInvoices();
      return this.invoices;
    },
    pdfLocation: function(code) {
      return process.env.VUE_APP_DOWNLOAD_URL + `invoice/${code}`;
    },
    onViewInvoice: function(invoice) {
      this.$emit('input', invoice);
    },
    viewInvoice: function(code) {
      const invoice = this.invoices.find((val) => val.code === code);
      this.onViewInvoice(invoice);
    },
  }
}
</script>

<style scoped>
.select-all {
  font-size: .813rem;
  width: 85px;
  font-weight: 700;
  border: 0;
}
</style>
